<script setup lang="ts">
import { computed } from 'vue';
import vAnimatedNumber, { AnimatedNumberDirectiveBindingOptions } from '../plugins/animatedNumberDirective';

const props = withDefaults(defineProps<{
	label?: string;
	value?: number;
	formatter?: ((value: number) => string | number) | null;
	suffix?: string;
	highlight?: boolean;
	options?: Partial<AnimatedNumberDirectiveBindingOptions>;
}>(), {
	label: '',
	value: 0,
	formatter: null,
	suffix: '',
	highlight: false,
	options: () => ({}),
});

const formatNumber = (value: number) => {
	if (props.formatter) {
		return String(props.formatter(value));
	}

	return String(Math.round(value));
};

const valueBindings = computed(() => ({ value: props.value, ...props.options }));
</script>

<template>
	<div
		class="flex flex-col"
		v-bind="$attrs"
	>
		<div
			class="text-xs phablet:text-sm font-normal tracking-wide"
			:class="{ 'text-secondary': highlight }"
		>
			<slot>
				{{ label }}
			</slot>
		</div>
		<span class="text-base phablet:text-xl text-white text-opacity-75 tracking-wide font-bold flex">
			<div v-animated-number:[formatNumber]="valueBindings" />{{ suffix }}
		</span>
	</div>
</template>
